// Hash any string into an integer value
export const hashCode = (str, hash) => {
  if (hash === undefined) {
    hash = 0
  }
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  return hash
}

// Convert an int to hexadecimal with a max length
// of six characters.
export const intToARGB = (i) => {
  var h =
    ((i >> 24) & 0xff).toString(16) +
    ((i >> 16) & 0xff).toString(16) +
    ((i >> 8) & 0xff).toString(16) +
    (i & 0xff).toString(16)
  return h.substring(0, 6)
}

export const hexToRgb = (hex) => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null
}

export const returnHTMLColor = (str) => intToARGB(hashCode(str))
